import script from './component-lib.esm90.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('SvgIcon', _vm._g(_vm._b({
    staticClass: "icon-wix-logo",
    attrs: {
      "viewBox": "0 0 460 178.98"
    }
  }, 'SvgIcon', Object.assign({}, _vm.$props, {
    title: _vm.$props.title || 'wix'
  }, _vm.$attrs), false), _vm.$listeners), [_c('path', {
    attrs: {
      "d": "M199.51,25.69,174.9,121,154.43,43c-5.53-23-15-34.88-34.81-34.88C100,8.12,90.4,19.75,84.81,43L64.34,121,39.73,25.69C35.74,6.48,17.15-1.82,0,.34l47.13,178.2s15.54,1.12,23.33-2.85c10.22-5.21,15.08-9.23,21.27-33.47,5.51-21.62,20.92-85.11,22.36-89.63,3.43-10.74,8-9.93,11.07,0,1.42,4.53,16.86,68,22.37,89.63,6.18,24.24,11.05,28.26,21.27,33.47,7.77,4,23.33,2.85,23.33,2.85L239.26.34c-17.56-2.21-35.81,6.42-39.75,25.35Zm83.22,3.74a28.83,28.83,0,0,1-9.68,8.32c-4.32,2.41-8.47,4-12.91,6.19-10.89,5.21-9.48,10-9.48,25.3v109.3s11.9,1.5,19.67-2.47c10-5.1,12.32-10,12.41-32.19v-108h0V29.43ZM400.2,89.86,460,.93S434.76-3.37,422.26,8c-9.55,8.69-17.54,21.23-38.94,52.08-.33.53-4.49,7.58-9.39,0C352.88,29.74,344.6,16.76,335,8,322.49-3.37,297.25.93,297.25.93l59.8,88.93-59.63,88.67s26.28,3.32,38.77-8.06c8.26-7.52,12.64-14.64,37.74-50.83,4.9-7.56,9-.55,9.4,0,21.13,30.46,28.2,41.73,38.19,50.83,12.5,11.38,38.33,8.06,38.33,8.06L400.2,89.86Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M282.74.14c0,9.37,1.49,23.5-20.61,31.5a35.63,35.63,0,0,0-11.47,7c0-22.28,3.39-30.35,12.51-35.12C270.18-.2,282.74.14,282.74.14Z"
    }
  })]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-57e642ea_0", {
    source: ".icon-wix-logo[data-v-57e642ea]{width:2.58em}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-57e642ea";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var __vue_component__$1 = __vue_component__;
export { __vue_component__$1 as default };